import { startLoading, stopLoading } from 'actions';
import api from 'api';
import { ModuleEnum } from 'constants/types/Module';
import { IThunkAction } from 'constants/types/IThunkAction';
import { errorHandler } from 'helpers/errorHandler';

export const getFinishedModules = (): IThunkAction => async (
  dispatch,
): Promise<void> => {
  try {
    startLoading()(dispatch);
    const cycleModules = await api.get('CycleModules');
    const modules = await api.get('modules');

    const data = [...cycleModules.data, ...modules.data];

    dispatch({
      type: ModuleEnum.FETCH_MODULES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    errorHandler(error);
    dispatch({
      type: ModuleEnum.FETCH_FINISHED_MODULE_FAILURE,
      error,
    });
  }
  stopLoading()(dispatch);
};
